export const DEFAULT_VALUE_STYLE = {
  Point: {
    icon: {
      icon_type: 'shape',
      shape_type: 'circle',
      fill: '#000000',
      stroke: '#000000',
      'fill-opacity': 1,
      use_stroke: false,
      'stroke-width': 1,
      'stroke-opacity': 1,
      image: null,
      image_id: null,
      sdf: false,
    },
    opacity: 1,
    size: 5,
    'circle-blur': 0,
    'circle-translate': [0, 0],
    'circle-pitch-alignment': 'viewport',
    'circle-pitch-scale': 'map',
    'icon-rotate': 0,
    'icon-anchor': 'center',
    'icon-offset': [0, 0],
    'icon-allow-overlap': false,
    'icon-ignore-placement': false,
  },
  Line: {
    stroke: '#000000',
    'stroke-opacity': 1,
    'stroke-width': 1,
    'stroke-dasharray': [],
    'line-cap': 'butt',
    'line-join': 'miter',
    'line-miter-limit': 2,
    'line-round-limit': 1.05,
    'line-blur': 0,
    'line-offset': 0,
    'line-gap-width': 0,
    'line-translate': [0, 0],
    'line-pattern-image_id': null,
  },
  Text: {
    fill: '#000000',
    'font-size': 10,
    label: 'name',
    'font-family': 'Arial Regular',
    'font-style': 'normal',
    'fill-opacity': 1,
  },
  Polygon: {
    fill: '#000000',
    'fill-opacity': 1,
    use_stroke: false,
    stroke: '#000000',
    'fill-antialias': true,
    'fill-translate': [0, 0],
    'fill-pattern-image_id': null,
  },
  Raster: {
    'raster-opacity': 1,
    'raster-hue-rotate': 0,
    'raster-brightness-min': 0,
    'raster-brightness-max': 1,
    'raster-saturation': 0,
    'raster-contrast': 0,
    'raster-fade-duration': 300,
    'raster-resampling': 'linear',
  },
}

export const DEFAULT_VALUE_LABEL_STYLE = {
  Point: {
    'text-size': 16,
    'text-color': '#333333',
    'text-opacity': 1,
    'text-halo-color': '#ffffff',
    'text-halo-width': 1.5,
    'text-halo-blur': 1,
    'text-offset': [0, 1],
    'text-ignore-placement': true,
    'text-allow-overlap': false,
    'text-anchor': 'center',
    'text-justify': 'auto',
    'text-transform': 'none',
    'text-rotate': 0,
    'text-padding': 2,
    'text-font': 'Arial Regular',
  },
  Line: {
    'text-size': 16,
    'text-color': '#333333',
    'text-opacity': 1,
    'text-halo-color': '#ffffff',
    'text-halo-width': 1.5,
    'text-halo-blur': 1,
    'symbol-placement': 'line',
    'symbol-spacing': 250,
    'text-keep-upright': true,
    'text-allow-overlap': false,
    'text-transform': 'none',
    'text-rotate': 0,
    'text-padding': 2,
    'text-font': 'Arial Regular',
  },
  Polygon: {
    'text-size': 16,
    'text-color': '#333333',
    'text-opacity': 1,
    'text-halo-color': '#ffffff',
    'text-halo-width': 1.5,
    'text-halo-blur': 1,
    'text-max-width': 10,
    'text-allow-overlap': false,
    'text-anchor': 'center',
    'text-justify': 'auto',
    'text-transform': 'none',
    'text-rotate': 0,
    'text-padding': 2,
    'text-font': 'Arial Regular',
  },
}
